import Phaser from 'phaser';

import { TRACING_GAME_TEXTURE_KEYS } from '../assets';

type CursorGuideConfig = {
	scene: Phaser.Scene;
	parent: Phaser.GameObjects.Container;
	cursor: Phaser.GameObjects.Arc;
};

const GUIDE = { dotDiameter: 12, dotSpacing: 32, color: 0xffffff };

export class CursorGuideController {
	private readonly scene: Phaser.Scene;
	private readonly parent: Phaser.GameObjects.Container;
	private readonly cursor: Phaser.GameObjects.Arc;
	private readonly container: Phaser.GameObjects.Container;
	private readonly line: Phaser.GameObjects.Graphics;
	private readonly target: Phaser.GameObjects.Image;
	private enabled = true;

	constructor({ scene, parent, cursor }: CursorGuideConfig) {
		this.scene = scene;
		this.parent = parent;
		this.cursor = cursor;
		this.line = scene.add.graphics();
		this.target = scene.add.image(0, 0, TRACING_GAME_TEXTURE_KEYS.outsideTapTarget);
		this.container = scene.add.container(0, 0, [this.line, this.target]).setDepth(1).setVisible(false);
		parent.add(this.container);
		scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
		cursor.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.hide, this);
		cursor.once(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
	}

	setEnabled(enabled: boolean) {
		this.enabled = enabled;
		if (!enabled) this.hide();
	}

	hide() {
		this.container.setVisible(false);
	}

	destroy() {
		this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
		this.cursor.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.hide, this);
		this.cursor.off(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
		this.container.destroy();
	}

	private onPointerDown(pointer: Phaser.Input.Pointer, currentlyOver: Phaser.GameObjects.GameObject[]) {
		if (!this.enabled || currentlyOver.includes(this.cursor)) return;

		const start = this.parent.getWorldTransformMatrix().applyInverse(pointer.worldX, pointer.worldY);
		const distance = Phaser.Math.Distance.Between(start.x, start.y, this.cursor.x, this.cursor.y);
		this.target.setPosition(start.x, start.y);
		this.line.clear().fillStyle(GUIDE.color);
		for (let offset = GUIDE.dotSpacing; offset < distance; offset += GUIDE.dotSpacing) {
			const progress = offset / distance;
			this.line.fillCircle(
				Phaser.Math.Linear(start.x, this.cursor.x, progress),
				Phaser.Math.Linear(start.y, this.cursor.y, progress),
				GUIDE.dotDiameter / 2,
			);
		}
		this.container.setVisible(true);
	}
}
